// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1fON8","load1":"Spinner_load1__26JB6"};